import React from 'react';
import loaderImg from "../../images/Favicon v2.png";
import './index.css';
const Loader = ({ title }) => {
    return (
        // <section className="container d-flex justify-content-center align-items-center flex-column" style={{ height: '100vh' }}>
        //     <img src={loaderImg} alt="loading" width={200}/>
        // <section className='section-loader'><div className='my-loader'></div></section> </section>
        <section className=" d-flex justify-content-center align-items-center flex-column loader_bg_color" style={{ height: '100vh' }}>
        <div class="loader">
            <div class="box">
                <div class="logo">
                    <img src={loaderImg} alt="loading" width={200} />
                </div>
            </div>
            <div class="box"></div>
            <div class="box"></div>
            <div class="box"></div>
            <div class="box"></div>
        </div></section>
    );
};

export default Loader;